<template>
    <div>
        <v-btn
            x-small
            depressed
            outlined
            color="primary"
            class="mb-2"
            @click="simDialog = true"
        >
            <v-icon small left>mdi-sim</v-icon>
            Ver Información del la SIM
        </v-btn>
        <v-dialog v-model="simDialog" max-width="700px">
            <v-card class="pa-4">
                <v-card-title class="d-flex justify-center">
                    <v-icon left>
                        mdi-sim
                    </v-icon>
                    <h3 class="font-weight-light text-capitalize">Información de la SIM</h3>
                </v-card-title>
                <v-card-text>
                    <div class="d-flex justify-space-between">
                        <div>
                            <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la SIM</strong></h3>
                            <div class="d-flex flex-column justify-center">
                                <h5 class="font-weight-light grey--text"><strong>ICC:</strong> {{ mobileline.simInfo.icc }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>IMSI:</strong> {{ mobileline.simInfo.imsi }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Red:</strong> {{ mobileline.simInfo.networkHost }}</h5>
                                <h5 class="font-weight-light grey--text"><strong>Tipo:</strong> {{ mobileline.simInfo.type }}</h5>
                            </div>
                        </div>
                        <div>
                            <h3 class="font-weight-light mt-4 mb-2"><strong>Credenciales de la SIM</strong></h3>
                            <div class="d-flex flex-column justify-center">
                                <h5 class="font-weight-light grey--text">
                                    <strong>PIN1:</strong> {{ seePIN1 ? mobileline.simInfo.pin1 : '****' }}
                                    <v-icon small @click="seePIN1 = !seePIN1">
                                        {{ seePIN1 ? 'mdi-eye-off' : 'mdi-eye' }}
                                    </v-icon>
                                </h5>
                                <h5 class="font-weight-light grey--text">
                                    <strong>PIN2:</strong> {{ seePIN2 ? mobileline.simInfo.pin2 : '****' }}
                                    <v-icon small @click="seePIN2 = !seePIN2">
                                        {{ seePIN2 ? 'mdi-eye-off' : 'mdi-eye' }}
                                    </v-icon>
                                </h5>
                                <h5 class="font-weight-light grey--text">
                                    <strong>PUK1:</strong> {{ seePUK1 ? mobileline.simInfo.puk1 : '*******' }}
                                    <v-icon small @click="seePUK1 = !seePUK1">
                                        {{ seePUK1 ? 'mdi-eye-off' : 'mdi-eye' }}
                                    </v-icon>
                                </h5>
                                <h5 class="font-weight-light grey--text">
                                    <strong>PUK2:</strong> {{ seePUK2 ? mobileline.simInfo.puk2 : '*******' }}
                                    <v-icon small @click="seePUK2 = !seePUK2">
                                        {{ seePUK2 ? 'mdi-eye-off' : 'mdi-eye' }}
                                    </v-icon>
                                </h5>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed text color="red" @click="simDialog=false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        simDialog: false,
        seePIN1: false,
        seePIN2: false,
        seePUK1: false,
        seePUK2: false,
    }),
    props: {
        mobileline: {
            type: Object,
            required: true,
        },
    },
};
</script>